// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__GYev7","text_wrapper":"Tag_text_wrapper__hZ3PX","close":"Tag_close__02nNk"};